import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GeographicalRegion, getInitGeographicalRegion } from '../../../models/geographical-region.model';
import { UtilitySharedService } from '../../../services/shared//utility-shared.service';
import { getInitSubGeographicalRegion, getInitSubGeographicalRegionDataIn, SubGeographicalRegion, SubGeographicalRegionDataIn } from '../../../models/sub-geographical-regions.model';
import { SubGeographicalRegionService } from '../../../services/sub-geographical-region.service';
import { GeographicalRegionService } from '../../../services/geographical-region.service';
import { ObjectDropdownComponent } from '../../common/object-dropdown/object-dropdown.component';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'lib-nec-district',
  standalone: false,
  templateUrl: './nec-district.component.html',
  styleUrls: ['./nec-district.component.scss','../network-entity-classes.component.scss']
})
export class NecDistrictComponent implements OnInit{
  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('dropdown') dropdown!: ObjectDropdownComponent;
  filterOpened: boolean = false;
  searchDropdownOpened: boolean = false;
  
  geoRegions: GeographicalRegion[] = [];
  public currentPage: number = 1;
  public pageSize: number = 10;
  pageSizes = [10, 20];
  public count: number = 0;
  utilityId: number = 0;
  isEdit: boolean = false;
  public searchText: string = '';

  districts: SubGeographicalRegion[] = []

  actionMenuOpenForId: number | null = null;
  selectedDistrict: SubGeographicalRegion = getInitSubGeographicalRegion();
  districtToSave: SubGeographicalRegionDataIn = getInitSubGeographicalRegionDataIn();
  geographicalRegionValue: GeographicalRegion | null = null;

  constructor(
    private toastr: ToastrService,
    private utilitySharedService: UtilitySharedService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private geographicalRegionService: GeographicalRegionService,
    public permissionsService: PermissionsService
  ) 
  {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.getAllSubGeographicalRegions();
    this.getAllGeographicalRegionsForSelect()
  }

  toggleMenu(district: any, event: MouseEvent) {
    event.stopPropagation();
    this.selectedDistrict = district;
    this.actionMenuOpenForId = this.actionMenuOpenForId === district.id ? null : district.id;
  }

  onRemove() {
    this.subGeographicalRegionService.delete(this.selectedDistrict.id!).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData?.message);
          this.reloadTable();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
    this.actionMenuOpenForId = null;
  }

  reloadTable(){
    this.getAllSubGeographicalRegions();
  }
  
  getAllSubGeographicalRegions(){
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        searchValue: this.searchText,
      },
      utilityId: this.utilitySharedService.getUtilityId(),
    };
    this.subGeographicalRegionService.getAll(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.districts = responseData.data.data;
          this.count = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  @HostListener('document:click')
  closeMenu() {
    if (this.actionMenuOpenForId !== null) {
      this.actionMenuOpenForId = null;
    }
  }

  openAddModal(){
    this.geographicalRegionValue = null;
    this.resetInputFields();
    this.isEdit = false;
    this.dropdown.selectItem(null);
  }

  selectDistrict(district: SubGeographicalRegion){
    this.selectedDistrict = district;
    this.geographicalRegionValue = district.geographicalRegion;
    this.openEditModal();
  }

  openEditModal(){
    this.resetInputFields();
    this.isEdit = true;
    this.fillInputFields();
  }

  updatedName: string = '';
  updatedCode: string = '';
  updatedNumber: string | null = null;
  updatedRegionId: number | null = null;

  private fillInputFields() {
    this.updatedName = this.selectedDistrict.name;
    this.updatedCode = this.selectedDistrict.code;
    this.updatedNumber = this.selectedDistrict.number;
    this.updatedRegionId = this.selectedDistrict.geographicalRegion.id;
  }

  private resetInputFields(){
    this.updatedName = '';
    this.updatedCode = '';
    this.updatedNumber = null;
    this.updatedRegionId = null;
  }

  private mapDistrict() {
    this.districtToSave.id = this.isEdit ? this.selectedDistrict.id : null;
    this.districtToSave.utilityId = this.utilityId;
    this.districtToSave.name = this.updatedName;
    this.districtToSave.code = this.updatedCode;
    this.districtToSave.number = this.updatedNumber;
    this.districtToSave.geographicalRegionId = this.updatedRegionId;
  }

  save(){
    const isNumberValid = this.updatedNumber ? /^7\d{3}$/.test(this.updatedNumber) : true;
    if(this.updatedName === ''){
      this.toastr.warning("Name can't be empty!")
    } else if (this.updatedCode === '') {
      this.toastr.warning("Code can't be empty!")
    } else if (this.updatedRegionId === null || this.updatedRegionId === undefined || this.updatedRegionId === 0) {
      this.toastr.warning("Please select a region!")
    } else if (!isNumberValid) {
      this.toastr.warning("Number must be 4 digits and to start with 7!")
    } else{
      this.mapDistrict();
      this.subGeographicalRegionService.save(this.districtToSave).subscribe({
        next: (response) => {
          if (response.body.status === 200 || response.body.status === 'OK') {
            this.closeEditModal?.nativeElement?.click();
            this.toastr.success(response.body.message);
            this.reloadTable();
          } else {
            this.toastr.error(response.body.message || 'Failed to save region');
          }
        },
        error: (_) => {
          this.toastr.error('Error occurred while saving region');
        },
      });
    }   
    this.actionMenuOpenForId = null;
  }

  getAllGeographicalRegionsForSelect() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.geoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading regions');
      },
    });
  }

  onSelectGeographicalRegion(obj: GeographicalRegion | null) {
    if (obj)
      this.updatedRegionId = obj.id;
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.reloadTable()
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.reloadTable()
  }
}